import React from "react";
import Loader_image from "../../assets/images/Pulse-1s-200px.svg";

function Loading({width, style, className="loader-spinner"}) {
    return (<>
        <div className={className} style={style} ><img width={width} src={Loader_image} alt="Loading"/></div>
    </>)
}

export default Loading